// 字段映射配置
const mappConfig = {
  TextFileInput: "TextFileInput",
  MergeJoin: "MergeJoin",
  Mapping: "Mapping",
  TextFileOutput: "TextFileOutput",
  RestMeta: "RestMeta",
  javaClass: "UserDefinedJavaClass",
  xmlData: "GetXMLData"
};
// 组件内容配置
//  const dataConfig=[
//     {text:'文本输入',type:'TextFileInput',icon:'icon-m-file-input'},
//     {text:'JSON输入',type:'JsonInput',icon:'icon-m-json-input'},
//     {text:'连接',type:'MergeJoin',icon:'icon-m-connect'},
//     {text:'字段映射',type:'Mapping',icon:'icon-m-mapping'},
//     {text:'文本输出',type:'TextFileOutput',icon:'icon-m-file-output'},
//     {text:'EC抽取器',type:'SAPSF',icon:'icon-m-ec'},
//     {text:'REST Client',type:'Rest',icon:'icon-m-api'},
//     {text:'Java代码',type:'UserDefinedJavaClass',icon:'icon-m-java'},
//     {text:'XML数据解析',type:'GetXMLData',icon:'icon-m-xml'},
//     {text:'JSON输出(P+)',type:'PeoplusJSON',icon:'icon-m-json-output'},
//     {text:'排序',type:'SortRows',icon:'icon-m-sort'},
//     {text:'等待...执行',type:'BlockUntilStepsFinish',icon:'icon-m-until-copy'},
//     {text:'过滤',type:'FilterRow',icon:'icon-m-percolator',icon:'icon-m-percolator'},
//     {text:'FTP文件下载',type:'SymSftpGet',icon:'icon-m-sftp-download'},
//     {text:'FTP文件上传',type:'SymSftpPut',icon:'icon-m-sftp-upload'},
//     {text:'FTP文件移动',type:'SymSftpMove',icon:'icon-m-sftp-move'},
//     {text:'FTP文件删除',type:'SymSftpDelete',icon:'icon-m-sftp-del'},
//     {text:'PGP加解密',type:'Pgp',icon:'icon-jiami1'},
//     {text:'数据校验',type:'Validator',icon:'icon-m-inspect'},
//     //{text:'设置变量',type:'SetVariable',icon:'icon-m-inspect'},
//    // {text:'获取变量',type:'GetVariable',icon:'icon-m-inspect'},
//     {text:'发送邮件',type:'SymMail',icon:'icon-m-mail'},
//     {text:'写属性文件',type:'PropertyOut',icon:'icon-m-properties-output'},
//     {text:'读属性文件',type:'PropertyIn',icon:'icon-m-properties-input'},
//     {text:'文件存在?',type:'FileExist',icon:'icon-m-sftp-check'},
//     {text:'按值分发',type:'SwitchCase',icon:'icon-m-switch-case'},
//     {text:'去重',type:'UniqueRows',icon:'icon-m-unique-rows'},
//     {text:'退出任务',type:'Abort',icon:'icon-m-abort'},
//     {text:'日志输出',type:'SymLog',icon:'icon-m-log'},
//     {text:'字段更改',type:'SelectValue',icon:'icon-m-fled'},
//     {text:'分支',type:'Dummy',icon:'icon-branch'},
//     {text:'上一步获取',type:'RowsFromResult',icon:'icon-get-last-step'},
//     {text:'复制记录',type:'RowsToResult',icon:'icon-copy-rows'},
//     {text:'字符替换',type:'ReplaceString',icon:'icon-replace'},

//     // {text:'转换',type:'Trans.job',icon:'icon-m-fled',belongto:'trans',show:false},
// ];

//  const jobDataConfig=[
//     {text:'开始',type:'Start.job',icon:'icon-start',show:false,belongto:'start'},
//     {text:'转换',type:'Trans.job',icon:'icon-transform',belongto:'trans',show:false},
//     {text:'作业',type:'Job.job',icon:'icon-job',belongto:'job',show:false},
//     {text:'文件存在?',type:'FileExist.job',icon:'icon-m-sftp-check',show:true},
//     {text:'发送邮件',type:'Mail.job',icon:'icon-m-mail',show:true},
//     {text:'等待',type:'Deplay.job',icon:'icon-m-until-copy',show:true},
//     {text:'空操作',type:'Dummy.job',icon:'icon-branch',show:true},
//     {text:'停止',type:'Abort.job',icon:'icon-stop',show:true},
// ];
//show 表示 true  表示显示粘贴 false不显示
const jobTreeData = [
  {
    id: 1,
    text: "通用",
    children: [
      {
        text: "开始",
        type: "Start.job",
        icon: "icon-start",
        show: false,
        belongto: "start",
        nodeActive: true
      },
      {
        text: "转换",
        type: "Trans.job",
        icon: "icon-transform",
        belongto: "trans",
        show: false,
        nodeActive: true
      },
      {
        text: "作业",
        type: "Job.job",
        icon: "icon-job",
        belongto: "job",
        show: false,
        nodeActive: true
      },
      { text: "空操作", type: "Dummy.job", icon: "icon-branch", show: true }
    ]
  },
  {
    id: 2,
    text: "条件",
    children: [
      {
        text: "文件存在?",
        type: "FileExist.job",
        icon: "icon-m-sftp-check",
        show: true
      },
      {
        text: "等待",
        type: "Deplay.job",
        icon: "icon-m-until-copy",
        show: true
      },
      {
        text: "检验字段的值",
        type: "SimpleEval.job",
        icon: "icon-field-verify",
        show: true
      }
    ]
  },
  {
    id: 3,
    text: "应用",
    children: [
      { text: "停止", type: "Abort.job", icon: "icon-stop", show: true },
      { text: "计数器", type: "Counter.job", icon: "icon-cnt", show: true },
      {
        text: "空数据流判断",
        type: "EmptyRows.job",
        icon: "icon-universal_template",
        show: true
      }
    ]
  },
  {
    id: 4,
    text: "邮件",
    children: [
      { text: "发送邮件", type: "Mail.job", icon: "icon-m-mail", show: true }
    ]
  }
];
const transTreeData = [
  {
    id: 1,
    text: "输入",
    children: [
      {
        text: "CSV输入",
        type: "TextFileInput",
        icon: "icon-m-file-input",
        iconColor: "#2db7f5"
      },
      { text: "JSON输入", type: "JsonInput", icon: "icon-m-json-input" },
      { text: "EC抽取器", type: "SAPSF", icon: "icon-m-ec" },
      {
        text: "XML数据解析",
        type: "GetXMLData",
        icon: "icon-m-xml",
        iconColor: "#2db7f5"
      },
      { text: "Excel输入", type: "ExcelInput", icon: "icon-excel-input" }
    ]
  },
  {
    id: 2,
    text: "输出",
    children: [
      { text: "文本输出", type: "TextFileOutput", icon: "icon-m-file-output" },
      {
        text: "JSON输出(P+)",
        type: "PeoplusJSON",
        icon: "icon-m-json-output",
        iconColor: "#2db7f5"
      }
    ]
  },
  {
    id: 3,
    text: "连接",
    children: [
      {
        text: "连接",
        type: "MergeJoin",
        icon: "icon-m-connect",
        iconColor: "#2db7f5"
      }
    ]
  },
  {
    id: 4,
    text: "数据处理",
    children: [
      {
        text: "字段映射",
        type: "Mapping",
        icon: "icon-m-mapping",
        transType: "mustInput"
      },
      {
        text: "排序",
        type: "SortRows",
        icon: "icon-m-sort",
        transType: "mustInput"
      },
      {
        text: "字段更改",
        type: "SelectValue",
        icon: "icon-m-fled",
        transType: "mustInput"
      },
      {
        text: "字符替换",
        type: "ReplaceString",
        icon: "icon-replace",
        transType: "mustInput"
      },
      {
        text: "通用模板",
        type: "Template",
        icon: "icon-universal_template",
        transType: "mustInput"
      },
      {
        text: "列转行",
        type: "Denormaliser",
        icon: "icon-universal_template",
        transType: "mustInput"
      },
      {
        text: "追加流",
        type: "Append",
        icon: "icon-universal_template",
        transType: "mustInput"
      }
    ]
  },
  {
    id: 41,
    text: "查询",
    children: [
      {
        text: "REST Client",
        type: "Rest",
        icon: "icon-m-api",
        transType: "mustInput"
      }
    ]
  },
  {
    id: 5,
    text: "脚本",
    children: [
      { text: "JAVA代码", type: "UserDefinedJavaClass", icon: "icon-m-java" }
    ]
  },
  {
    id: 6,
    text: "流程",
    children: [
      {
        text: "等待...执行",
        type: "BlockUntilStepsFinish",
        icon: "icon-m-until-copy"
      },
      {
        text: "过滤",
        type: "FilterRow",
        icon: "icon-m-percolator",
        transType: "mustInput"
      },
      {
        text: "按值分发",
        type: "SwitchCase",
        icon: "icon-m-switch-case",
        transType: "mustInput"
      },
      {
        text: "去重",
        type: "UniqueRows",
        icon: "icon-m-unique-rows",
        transType: "mustInput"
      },
      { text: "退出任务", type: "Abort", icon: "icon-m-abort" }
    ]
  },
  {
    id: 7,
    text: "文件传输",
    children: [
      {
        text: "SFTP文件下载",
        type: "SymSftpGet",
        icon: "icon-m-sftp-download"
      },
      { text: "SFTP文件上传", type: "SymSftpPut", icon: "icon-m-sftp-upload" },
      { text: "SFTP文件移动", type: "SymSftpMove", icon: "icon-m-sftp-move" },
      { text: "SFTP文件删除", type: "SymSftpDelete", icon: "icon-m-sftp-del" }
    ]
  },
  {
    id: 8,
    text: "加解密",
    children: [
      {
        text: "PGP加解密",
        type: "Pgp",
        icon: "icon-jiami1",
        transType: "mustInput"
      }
    ]
  },
  {
    id: 9,
    text: "校验",
    children: [{ text: "数据校验", type: "Validator", icon: "icon-m-inspect" }]
  },
  {
    id: 10,
    text: "应用",
    children: [
      {
        text: "发送邮件",
        type: "SymMail",
        icon: "icon-m-mail",
        transType: "mustInput"
      },
      {
        text: "日志输出",
        type: "SymLog",
        icon: "icon-m-log",
        transType: "mustInput"
      },
      {
        text: "文件处理",
        type: "ProcessFiles",
        icon: "",
        transType: "mustInput"
      }
    ]
  },
  {
    id: 11,
    text: "文件管理",
    children: [
      {
        text: "写属性文件",
        type: "PropertyOut",
        icon: "icon-m-properties-output",
        transType: "mustInput"
      },
      {
        text: "读属性文件",
        type: "PropertyIn",
        icon: "icon-m-properties-input"
      }
    ]
  },
  {
    id: 12,
    text: "条件",
    children: [
      { text: "文件存在?", type: "FileExist", icon: "icon-m-sftp-check" },
      { text: "空操作", type: "Dummy", icon: "icon-branch" }
    ]
  },

  {
    id: 13,
    text: "作业",
    children: [
      {
        text: "上一步获取",
        type: "RowsFromResult",
        icon: "icon-get-last-step"
      },
      {
        text: "复制记录",
        type: "RowsToResult",
        icon: "icon-copy-rows",
        transType: "mustInput"
      },
      { text: "设置变量", type: "SetVariable", icon: "icon-setting_variables" },
      { text: "获取变量", type: "GetVariable", icon: "icon-get_variable" }
    ]
  }
];
function dealTreeData(tree) {
  return Array.prototype.concat.apply(
    [],
    tree.map(item => {
      return item.children;
    })
  );
}
const jobDataConfig = dealTreeData(jobTreeData);
const dataConfig = dealTreeData(transTreeData);
const jobType = [
  "Trans.job",
  "Job.job",
  "FileExist.job",
  "Mail.job",
  "Deplay.job",
  "Dummy.job",
  "Abort.job",
  "SimpleEval.job",
  "Counter.job",
  "EmptyRows.job"
];
const VERSION = "2.0";
const ZOOM = 80;
export {
  mappConfig,
  dataConfig,
  VERSION,
  jobDataConfig,
  jobType,
  jobTreeData,
  transTreeData,
  ZOOM
};



// WEBPACK FOOTER //
// ./src/pages/flow/config.js